// src/components/ForbiddenPage.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getToken } from 'utils/helpers';

const ForbiddenPage: React.FC = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        const token = getToken();
        if (token) {
            navigate('/');
        } else {
            navigate('/login');
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            textAlign="center"
            bgcolor="background.default"
        >
            <Typography variant="h1" color="error">
                403
            </Typography>
            <Typography variant="h4" gutterBottom>
                Access Forbidden
            </Typography>
            <Typography variant="body1" paragraph>
                You do not have permission to access this page.
            </Typography>
            <Button variant="contained" color="primary" onClick={handleGoHome}>
                Go to Home
            </Button>
        </Box>
    );
};

export default ForbiddenPage;
